import { render } from "./EditItems.vue?vue&type=template&id=baf83060"
import script from "./EditItems.vue?vue&type=script&lang=js"
export * from "./EditItems.vue?vue&type=script&lang=js"
script.render = render

export default script